import PostDisplay from '@components/feeds/post/PostDisplay'
import { postTypes } from '@utils/postDisplayParser'

const Post = ({ post, ...rest }) => {
  let base, replyTop, replyBottom

  switch (post?.display?.postType) {
    case postTypes.BASE:
      base = post?.display?.data?.base
      // short circuit if post does not have necessary properties
      if (!base?.post?.dimensions || !base?.post?.displayType) return;
      return (
        <PostDisplay
          post={base.post}
          user={base.user}
          mainPost={post}
          {...rest}
        />
      )
    case postTypes.REPOST:
      base = post?.display?.data?.base
      // short circuit if post does not have necessary properties
      if (!base?.post?.dimensions || !base?.post?.displayType) return;
      return (
        <PostDisplay
          post={base.post}
          user={base.user}
          mainPost={post}

          reposter={post.user}
          reposterPost={post}

          {...rest}
        />
      )
    case postTypes.REPLY_TOP_BOTTOM:
      replyTop = post?.display?.data?.replyTop
      replyBottom = post?.display?.data?.replyBottom
      // short circuit if post does not have necessary properties
      if (!replyTop?.post?.dimensions || !replyTop?.post?.displayType) return;
      if (!replyBottom?.post?.dimensions || !replyBottom?.post?.displayType) return;
      return (
        <>
          <PostDisplay
            post={replyTop.post}
            user={replyTop.user}
            mainPost={post}

            {...rest}
          />
          <PostDisplay
            post={replyBottom.post}
            user={replyBottom.user}
            mainPost={post}

            {...rest}
          />
        </>
      )
    case postTypes.REPLY_BOTTOM_ONLY:
      replyBottom = post?.display?.data?.replyBottom
      // short circuit if post does not have necessary properties
      if (!replyBottom?.post?.dimensions || !replyBottom?.post?.displayType) return;
      return (
        <PostDisplay
          post={replyBottom.post}
          user={replyBottom.user}
          mainPost={post}

          {...rest}
        />
      )
    default:
      console.log('POST DID NOT RENDER', post)
  }
}

export default Post